import React, { FC } from 'react'
import './YoutubeEmbed.css'

export interface Props {
    embedId: string;
}

const YoutubeEmbed: React.FC<Props> = ({ embedId }) => {
    return (
        <div>
            <iframe className="youtube-video"
                src={`https://www.youtube.com/embed/${embedId}?enablejsapi=1&version=3&playerapiid=ytplayer`}
                frameBorder="0"
                allowFullScreen></iframe>
        </div>
    )
}

export default YoutubeEmbed
